import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { RegisterSectionsQuery } from '../../course_scheduler/queries/register_sections_query';
import { IRegistrationSelectedSectionsModel } from '../models/registration_selected_sections_model';
import { RegistrationFacade } from '../facades/registration_facade';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { TransientAccessCredEventNames } from '../../../prevent_transient_access/constants/transient_access_cred_constants';
import { RegistrationSectionFacade } from '../facades/registration_section_facade';

export type ToggleRegistrationFriendlyReminderPromptCommand = (
  showPrompt: boolean,
  regBind: () => angular.IPromise<any>,
  closePromptBind: () => void
) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'toggleRegistrationFriendlyReminderPromptCommand',
    (
      defineCommandORM: IDefineCommand,
      ngRegistrationSelectedSectionsModel: IRegistrationSelectedSectionsModel,
      ngRegisterSectionsQuery: RegisterSectionsQuery,
      ngRegistrationSectionFacade: RegistrationSectionFacade,
      ngComponentCommunicatorService: CommunicatorService
    ) =>
      defineCommandORM(
        'toggleRegistrationFriendlyReminderPromptCommand',
        (deferred, showPrompt: boolean, regBind: () => angular.IPromise<any>, closePromptBind: () => void) => {
          if (!showPrompt) {
            ngRegistrationSelectedSectionsModel.write({
              showRegistrationPrompt: false
            });
            ngComponentCommunicatorService.release(TransientAccessCredEventNames.NEW_CRED_SAVED, regBind);
            ngComponentCommunicatorService.release(
              TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
              closePromptBind
            );
            return deferred.resolve();
          }
          ngRegistrationSelectedSectionsModel.write({
            unselectedSections: ngRegistrationSectionFacade.getUnselectedScheduledNonWaitlistedSections(),
            coReqMissingSections: _4.uniqBy(ngRegisterSectionsQuery.result.coReqMissingSections, 'course'),
            preReqMissingSections: _4.uniqBy(ngRegisterSectionsQuery.result.preReqMissingSections, 'course'),
            showRegistrationPrompt: true
          });

          ngComponentCommunicatorService.subscribe(TransientAccessCredEventNames.NEW_CRED_SAVED, regBind);
          ngComponentCommunicatorService.subscribe(
            TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
            closePromptBind
          );
          return deferred.resolve();
        }
      )
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/commands/toggle_registration_friendly_reminder_prompt_command.ts